// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"72f7cc96","453":"71172d06","555":"059c9c30","633":"d42878e1"}[chunkId] + ".chunk.js";
};